import { render, staticRenderFns } from "./DigitInput.vue?vue&type=template&id=2e30bece&scoped=true"
import script from "./DigitInput.vue?vue&type=script&lang=js"
export * from "./DigitInput.vue?vue&type=script&lang=js"
import style0 from "./DigitInput.vue?vue&type=style&index=0&id=2e30bece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e30bece",
  null
  
)

export default component.exports